<script>
    import Fa from 'svelte-fa';
    import { faChevronDown } from '@fortawesome/pro-regular-svg-icons';

    import { page } from '$app/stores';
    import { goto } from '$app/navigation';

    import Button from '$lib/components/Button.svelte';

    export let selected;
    export let classes = '';

    // sortKey Options
    let sortKey = [
        {
            value: 'COLLECTION_DEFAULT',
            label: 'Featured'
        },
        {
            value: 'BEST_SELLING',
            label: 'Best Selling'
        },
        {
            value: 'CREATED',
            label: 'Newest'
        },
        {
            value: 'PRICE',
            label: 'Lowest Price'
        }
    ];

    // defaul or selected sortKey
    $: selectedSortby = selected || 'COLLECTION_DEFAULT';
    $: selectedLabel = sortKey.find((item) => item.value === selectedSortby) || sortKey[0];

    // update url params with sortKey & goto
    function updateSelectedSortBy(event) {
        selectedSortby = event.currentTarget.value;
        const searchParams = new URLSearchParams($page.url.searchParams);
        searchParams.set('sortBy', selectedSortby);
        goto(`${$page.url.pathname}${searchParams ? '?' : ''}${searchParams.toString()}`, { replaceState: true, noScroll: true });
    }

    // sort draw show/hide based on filterId as value
    $: sortDrawerOpen = '';
</script>

<button
    class={`fixed left-0 top-0 h-screen w-screen bg-black/40 dark:bg-black/20
    ${sortDrawerOpen.length ? 'z-30 block' : 'z-0 hidden'}`}
    on:click={() => (sortDrawerOpen = '')}
/>

<button
    class={`relative z-20 flex shrink-0 items-center justify-center rounded-full border border-color-text/40 bg-color-background px-5 py-1 text-sm 
          ${selectedSortby !== 'COLLECTION_DEFAULT' ? 'border-primary bg-primary text-white' : 'border-color-text/40 bg-color-background'} ${classes}`}
    on:click={() => (sortDrawerOpen = 'open')}
>
    Sort: {selectedLabel.label}
    <Fa icon={faChevronDown} size="0.8x" class="ml-1" />
</button>

<div
    class={`draw-bottom fixed bottom-0 left-0 z-30 min-h-[60vh] w-full rounded-t-xl bg-base-900 shadow-2xl lg:absolute lg:bottom-auto
            lg:left-auto lg:right-0 lg:top-12 lg:block lg:min-h-0 lg:w-72 lg:overflow-hidden lg:rounded-xl lg:shadow-2xl
            ${sortDrawerOpen === 'open' ? 'open' : ''}`}
>
    <div class="overflow-hidden rounded-t-xl bg-base-800 p-2">
        <div class="text-center text-base font-semibold uppercase lg:text-sm">Sort By</div>
        <p class="text-center text-sm lg:text-xs">Choose one option</p>
    </div>
    <ul class="no-scrollbar max-h-[60vh] overflow-y-scroll pb-20 lg:max-h-96 lg:pb-0">
        {#each sortKey as sort (sort.value)}
            <li class="relative">
                <input
                    class="absolute right-7 top-5"
                    type="radio"
                    id={sort.value}
                    name="sort"
                    value={sort.value}
                    checked={selectedSortby === sort.value}
                    on:change={updateSelectedSortBy}
                />

                <label for={sort.value}>
                    <div
                        class="rounded-xs inline-block w-full cursor-pointer border-t
                                        border-color-text/10 px-7 py-4 hover:bg-base-800/40 lg:text-sm"
                    >
                        {sort.label}
                    </div>
                </label>
            </li>
        {/each}
    </ul>

    <div class=" absolute bottom-0 grid w-full grid-cols-12 items-center justify-center bg-base-800 p-3.5 text-center lg:relative">
        <div class="col-span-12">
            <Button style="Primary" size="Small" onclick={() => (sortDrawerOpen = '')}>View Results</Button>
        </div>
    </div>
</div>

<style>
    @media only screen and (max-width: 728px) {
        .draw-bottom {
            width: 100%;
            bottom: -100%;
            transition: bottom 0.4s cubic-bezier(0.82, 0.085, 0.395, 0.895);
        }
        .draw-bottom.open {
            bottom: 0px;
        }
    }
    @media only screen and (min-width: 729px) {
        .draw-bottom {
            display: none;
        }
        .draw-bottom.open {
            display: block;
        }
    }
</style>
